import { ErrorCircleRegular } from '@fluentui/react-icons'
import styles from './UnableToLoadData.module.css'

export const UnableToLoadData = ({ message }: { message: string }) => (
  <div className={styles.container}>
    <ErrorCircleRegular style={{ marginRight: '0.5rem' }} />
    <p className={styles.message}>{message ?? 'Något oväntat gick fel'}</p>
  </div>
)
